import { render, staticRenderFns } from "./ObservacoesAjustePedido.vue?vue&type=template&id=b89a3bf4"
import script from "./ObservacoesAjustePedido.vue?vue&type=script&setup=true&lang=js"
export * from "./ObservacoesAjustePedido.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports